import React from "react";

const NotFound = () => {
  return (
    <>
      <center>
        <img
          src="https://img.freepik.com/premium-vector/page-found-404-error-concept-illustration_270158-294.jpg?w=740"
          alt="NotFound"
          style={{ maxHeight: "500px" }}
        />
        <br />
        <a href={"/"}>
          <button className="wpcf7-form-control wpcf7-submit has-spinner tertiary-background">
            Go To HomePage
          </button>
        </a>
        <br /> <br />
      </center>
    </>
  );
};

export default NotFound;
